<template>
    <div
        v-if="showLarge || isDesigner"
        v-bind:class="baseClass"
        v-bind:style="inlineStyle"
        class="chevron-text">
        {{ content }}
    </div>
    <div
        v-else
        v-bind:class="baseClass"
        v-bind:data-test-content="content"
        class="chevron-small flex-grow-1">
        {{ isPresent ? content : "&zwnj;" }}
    </div>
</template>
<script>
    import { responsiveManager } from "Responsive/manager";
    export default {
        props: {
            isPresent: { type: Boolean, required: false, default: false },
            isDisabled: { type: Boolean, required: false, default: false },
            isDesigner: { type: Boolean, required: false, default: false },
            overrideHeight: { type: Number, required: false, default: 0 },
            content: { type: String, required: true }
        },
        computed: {
            showLarge() {
                return responsiveManager.md.value;
            },
            baseClass() {
                return this.isPresent
                    ? "chevron-present-milestone"
                    : this.isDisabled
                      ? "chevron-disabled-milestone"
                      : this.isDesigner
                        ? "chevron-designer-milestone"
                        : "chevron-past-milestone";
            },
            inlineStyle() {
                if (this.overrideHeight > 0) {
                    return { height: `${this.overrideHeight}px` };
                }
                return {};
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "./_milestone-styles.scss";
</style>
